type Nullable<T> = T | null | undefined;

export function currencyFormatter(dollars: number): string {
  const minimumFractionDigits = dollars % 1 === 0 ? 0 : 2;
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits
  });

  return currencyFormatter.format(dollars);
}

export function currencyInCentsFormatter(cents: number): string {
  return currencyFormatter(cents / 100);
}

export function currencyDollarsToCentsFormatter(dollars: Nullable<number>): number | null {
  if (dollars == null) return null;
  return Math.round(dollars * 100);
}

export function parseStringToDollars(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === '') return null;

  const parsed = parseFloat(trimmed);
  return isNaN(parsed) ? null : parsed;
}
